import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';

// import '@ant-design/compatible/assets/index.css';


import { Tabs, Col, Row, Form, DatePicker, Spin } from 'antd';
import DF from 'DisplayFramework';
import FormInput from 'components/FormInput';
import { FormInstance } from 'antd/lib/form';
import { getThirdPartyById } from 'services/thirdParty';
import Text from 'antd/lib/typography/Text';
import { shouldUpdateCompare } from 'utils/utils2';
import moment from 'moment';
import ParListSelect from 'components/ParListSelect';
import MgUserListByJobSelect from 'components/MgUserListByJobSelect';
import GetLabel from 'DisplayFramework/components/GetLabel';

const { TabPane } = Tabs;
export type TabTPCorrespondentProps = {
  objectid?: number;
  form?: FormInstance;
  mgid: number;
  setSuccessful?: any;
};

const TabTPCorrespondent = ({
  mgid,
  objectid,
  form,
  setSuccessful,
}: TabTPCorrespondentProps) => {
  // eslint-disable-next-line no-unused-vars
  const [state, setState] = useState<any>({
    correspondent: {},
    generalData: {},
  });
  const { data, isFetching } = useQuery(
    ['getThirdPartyByIdCorr', { tpid: objectid }],
    () => getThirdPartyById({ tpid: objectid! }).then((res) => res.data),
    { enabled: true }
  );

  useEffect(() => {
    setSuccessful(isFetching);
  }, [isFetching]);

  return (
    <DF.Provider pagcode="TabTPCorrespondent">
      <Spin spinning={isFetching}>
        <Row>
          <Col span={24}>
            <Tabs animated defaultActiveKey="1" type="line">
              <TabPane tab={<GetLabel label="ChangeCorrespondent"/> } key="1" forceRender>
                <Row gutter={16}>
                  <Col xs={8}>
                    <FormInput
                      name="tpcorrespondenttype"
                      rules={[{ required: true }]}
                    >
                      <ParListSelect
                        onChange={(e) => {
                          form?.setFieldsValue({ tpuserid: '' });
                        }}
                        parcode="TPCORRTYPE"
                      ></ParListSelect>
                    </FormInput>
                  </Col>

                  <Col xs={8}>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tpcorrespondenttype')}
                      noStyle
                    >
                      {({ getFieldValue }) => {
                        const tspcorrtype = getFieldValue(
                          'tpcorrespondenttype'
                        );
                        var currentCorr;
                        if (tspcorrtype === 'SALE') {
                          currentCorr = data?.correspondent?.tpsaleusername;
                        }
                        if (tspcorrtype === 'BO') {
                          currentCorr = data?.correspondent?.tpbousername;
                        }
                        if (tspcorrtype === 'RISK') {
                          currentCorr = data?.correspondent?.tpriskusername;
                        }
                        if (tspcorrtype === 'REC') {
                          currentCorr = data?.correspondent?.tprecusername;
                        }
                        if (tspcorrtype === 'LP') {
                          currentCorr = data?.correspondent?.tplpusername;
                        }

                        return (
                          <FormInput name="currentCorrUser">
                            <Text>{currentCorr}</Text>
                          </FormInput>
                        );
                      }}
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col xs={8}>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tpcorrespondenttype')}
                      noStyle
                    >
                      {({ getFieldValue }) => (
                        <FormInput name="tpuserid" rules={[{ required: true }]}>
                          <MgUserListByJobSelect
                            mgid={mgid}
                            jobcode={getFieldValue('tpcorrespondenttype')}
                          />
                        </FormInput>
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={8}>
                    <FormInput
                      name="tpuserdate"
                      labelCol={{ span: 8 }}
                      wrapperCol={{ span: 16 }}
                    >
                      <DatePicker defaultValue={moment()} />
                    </FormInput>
                  </Col>
                </Row>
              </TabPane>
            </Tabs>
          </Col>
        </Row>
      </Spin>
    </DF.Provider>
  );
};
export default TabTPCorrespondent;
